<template>
    <div class="layout-footer">
        <span class="inline text-muted-color">COPYRIGHT © {{ new Date().getFullYear() }}
            <router-link :to="{ name: 'emails' }">
                Mail Sender</router-link>, All rights Reserved
        </span>
    </div>
</template>

<script setup lang="ts">
</script>
